import { pointAtSegments, angleAtSegments, distanceAtSegment, lengthOfSegment } from './segments';
import { getBBoxByArray } from './util';
export default {
    /**
     * è®¡ç®å¤æçº¿çåå´ç
     * @param {array} points ç¹çéå [x,y] çå½¢å¼
     * @return {object} åå´ç
     */
    box: function (points) {
        var xArr = [];
        var yArr = [];
        for (var i = 0; i < points.length; i++) {
            var point = points[i];
            xArr.push(point[0]);
            yArr.push(point[1]);
        }
        return getBBoxByArray(xArr, yArr);
    },
    /**
     * è®¡ç®å¤æçº¿çé¿åº¦
     * @param {array} points ç¹çéå [x,y] çå½¢å¼
     * @return {object} å¤æ¡è¾¹çé¿åº¦
     */
    length: function (points) {
        return lengthOfSegment(points);
    },
    /**
     * æ ¹æ®æ¯ä¾è·åå¤æçº¿çç¹
     * @param {array} points ç¹çéå [x,y] çå½¢å¼
     * @param {number} t å¨å¤æçº¿çé¿åº¦ä¸çæ¯ä¾
     * @return {object} æ ¹æ®æ¯ä¾å¼è®¡ç®åºæ¥çç¹
     */
    pointAt: function (points, t) {
        return pointAtSegments(points, t);
    },
    /**
     * æå®ç¹å°å¤æçº¿çè·ç¦»
     * @param {array} points ç¹çéå [x,y] çå½¢å¼
     * @param {number} x æå®ç¹ç x
     * @param {number} y æå®ç¹ç y
     * @return {number} ç¹å°å¤æçº¿çè·ç¦»
     */
    pointDistance: function (points, x, y) {
        return distanceAtSegment(points, x, y);
    },
    /**
     * æ ¹æ®æ¯ä¾è·åå¤æçº¿çåçº¿è§åº¦
     * @param {array} points ç¹çéå [x,y] çå½¢å¼
     * @param {number} t å¨å¤æçº¿çé¿åº¦ä¸çæ¯ä¾
     * @return {object} æ ¹æ®æ¯ä¾å¼è®¡ç®åºæ¥çè§åº¦
     */
    tangentAngle: function (points, t) {
        return angleAtSegments(points, t);
    },
};
//# sourceMappingURL=polyline.js.map